import { render, staticRenderFns } from "./ReleaseNotesCard.vue?vue&type=template&id=cce0d270&scoped=true"
import script from "./ReleaseNotesCard.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesCard.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNotesCard.vue?vue&type=style&index=0&id=cce0d270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce0d270",
  null
  
)

export default component.exports